export const questionnaireData = [
  {
    id: 1,
    title: "Business Goals and Financials",
    description: "Please tell us about your company goals and financials",
    questions: [
        {
            id: "q1_1",
            text: "What is the name of your company?",
            type: "text",
            required: true,
            placeholder: "Enter company name"
        },
        {
            id: "q1_2",
            text: "What industry does your company operate in?",
            type: "dropdown",
            required: true,
            options: [
                { value: "", label: "Select an industry" },
                { value: "retail", label: "Retail" },
                { value: "restaurants", label: "Restaurants" },
                { value: "construction", label: "Construction" },
                { value: "manufacturing", label: "Manufacturing" },
                { value: "professional_services", label: "Professional Services" },
                { value: "healthcare", label: "Healthcare (Non-Medical)" },
                { value: "ecommerce", label: "E-commerce" },
                { value: "wholesale_distribution", label: "Wholesale/Distribution" },
                { value: "auto_repair", label: "Auto Repair" },
                { value: "beauty_personal_care", label: "Beauty/Personal Care" },
                { value: "it_services", label: "IT Services" },
                { value: "other", label: "Other" }
            ]
        },
        {
            id: "q1_3",
            text: "How many employees does your company have?",
            type: "number",
            required: true,
            placeholder: "Enter number of employees"
        },
        {
            id: "q1_4",
            text: "How soon do you plan to exit or sell your company?",
            type: "dropdown",
            required: true,
            options: [
                { value: "", label: "Select exit/sale plan" },
                { value: "0-1_years", label: "0-1 years" },
                { value: "1_2_years", label: "1-2 years" },
                { value: "2_5_years", label: "2-5 years" },
                { value: "5_plus_years", label: "5+ years" }
            ]
        },
        {
            id: "q1_5",
            text: "If you received an acceptable offer in next 30-45 days, would you consider selling?",
            type: "yes_no",
            required: true
        },
        {
            id: "q1_6",
            text: "How would your business perform if you left tomorrow?",
            type: "dropdown",
            required: true,
            options: [
                { value: "", label: "Select exit/sale plan" },
                { value: "business_would_fall_apart_without_me", label: "Business would fall apart without me" },
                { value: "business_would_struggle_some_but_remain_functioning", label: "Business would struggle some but remain functioning" },
                { value: "business_would_run_well_independently_with_strong_management", label: "Business would run well/independently with strong management" },
            ]
        },
        {
            id: "q1_7",
            text: "What do you think your business is worth currently? (Most businesses are worth 3-4 times SDE (Sellers Discretionary Earnings)",
            type: "currency",
            required: true,
            placeholder: "Enter estimated value"
        },
        {
            id: "q1_8",
            text: "What price do you want your company to sell for at exit?",
            type: "currency",
            required: true,
            placeholder: "Enter estimated value"
        },
        {
            id: "q1_9",
            text: "What was your Total Revenue for Last Year?",
            type: "currency",
            required: true,
            placeholder: "Enter estimated value"
        },
        {
            id: "q1_10",
            text: "What was your Total Profit for Last Year?",
            type: "currency",
            required: true,
            placeholder: "Enter estimated value"
        },
        {
            id: "q1_11",
            text: "What is your Estimated Total Revenue for This Year?",
            type: "currency",
            required: true,
            placeholder: "Enter estimated value"
        },
        {
            id: "q1_12",
            text: "What is your Estimated Total Profit for This Year?",
            type: "currency",
            required: true,
            placeholder: "Enter estimated value"
        }
    ]
  },
  {
    id: 2,
    title: "Business Performance & Transferability",
    description: "",
    questions: [
        {
            id: "q2_1",
            text: "How audited, current, & due diligence-ready are your financial statements?",
            type: "scale",
            required: true,
            benchmark: "3 years of financials, Clean Books, Third-party audits completed"
        },
        {
            id: "q2_2",
            text: "How clear & consistent are your profitability & cash flow trends?",
            type: "scale",
            required: true,
            benchmark: "Margins are higher than Industry average, Positive cash flow for last 3 years"
        },
        {
            id: "q2_3",
            text: "How credible & recent is your business valuation?",
            type: "scale",
            required: true,
            benchmark: "Valuation by a certified firm within the last 6-12 months, aligned with industry & market trends"
        },
        {
            id: "q2_4",
            text: "How diversified is your customer base to reduce revenue risk?",
            type: "scale",
            required: true,
            benchmark: "No single customer exceeds 10% of revenue, with 50+ active clients"
        },
        {
            id: "q2_5",
            text: "How documented, current, & transferable are customer contracts?",
            type: "scale",
            required: true,
            benchmark: "All contracts digitized, auto-renewing, & transferable without restrictions"
        },
        {
            id: "q2_6",
            text: "How consistent is your sales growth over the past three years?",
            type: "scale",
            required: true,
            benchmark: "10-15%+ year-over-year sales growth, tracked regularly"
        },
        {
            id: "q2_7",
            text: "How clear & customer-recognized is your brand's unique value proposition?",
            type: "scale",
            required: true,
            benchmark: "80% of surveyed customers can articulate brand's Unique Value Proposition"
        },
        {
            id: "q2_8",
            text: "How effective & measurable are your documented marketing strategies?",
            type: "scale",
            required: true,
            benchmark: "Marketing ROI exceeds 4:1, with campaigns tracked"
        },
        {
            id: "q2_9",
            text: "How strong is your market position compared to competitors?",
            type: "scale",
            required: true,
            benchmark: "Ranked top 2 in industry market share, per third-party reports"
        },
        {
            id: "q2_10",
            text: "How documented are customer relationships for annual revenue planning?",
            type: "scale",
            required: true,
            benchmark: "CRM tracks all relationships, with ~90%+ retention rate year over year"
        },
        {
            id: "q2_11",
            text: "How clear is your documented growth strategy for new markets/products?",
            type: "scale",
            required: true,
            benchmark: "3-year growth plan targets 15%+ revenue increase, actionable plans in place"
        },
        {
            id: "q2_12",
            text: "How well-identified are potential new revenue streams?",
            type: "scale",
            required: true,
            benchmark: "1-2 new revenue streams in works, or contributing 10% to sales"
        },
        {
            id: "q2_13",
            text: "How capable is your management team of running the business without you?",
            type: "scale",
            required: true,
            benchmark: "Management runs operations for 30+ days without owner input"
        },
        {
            id: "q2_14",
            text: "How clearly documented are leadership roles & responsibilities?",
            type: "scale",
            required: true,
            benchmark: "Org chart & role descriptions updated quarterly in a shared system"
        },
        {
            id: "q2_15",
            text: "How robust is your succession plan for key leadership positions?",
            type: "scale",
            required: true,
            benchmark: "Succession plan tested annually with identified backups for all roles"
        }
    ]
  },
  {
    id: 3,
    title: "Business Performance & Transferability",
    description: "",
    questions: [
        {
            id: "q3_1",
            text: "How low is employee turnover & high are morale & competency?",
            type: "scale",
            required: true,
            benchmark: "Turnover below 10%, with 90%+ employee satisfaction scores"
        },
        {
            id: "q3_2",
            text: "How well-documented & automated are core business processes?",
            type: "scale",
            required: true,
            benchmark: "80% of processes automated, with SOPs stored in a system"
        },
        {
            id: "q3_3",
            text: "How secure, scalable, & licensed are your IT systems?",
            type: "scale",
            required: true,
            benchmark: "Zero breaches in 5 years, with scalable SaaS platforms fully licensed"
        },
        {
            id: "q3_4",
            text: "How seamlessly can operations continue during an ownership transition?",
            type: "scale",
            required: true,
            benchmark: "90-day transition would have No operational disruptions"
        },
        {
            id: "q3_5",
            text: "How current, secure, & licensed are your technology systems?",
            type: "scale",
            required: true,
            benchmark: "All systems updated yearly( SOC 2 compliance), No major upgrades needed"
        },
        {
            id: "q3_6",
            text: "How valuable are proprietary tech or innovations to your advantage?",
            type: "scale",
            required: true,
            benchmark: "Proprietary tech drives 15%+ revenue, patented & unique"
        },
        {
            id: "q3_7",
            text: "How optimized are key operational processes for cost-effectiveness?",
            type: "scale",
            required: true,
            benchmark: "10-15% cost reduction via process optimization in past 2 years"
        },
        {
            id: "q3_8",
            text: "How scalable are operations to handle increased demand?",
            type: "scale",
            required: true,
            benchmark: "Operations can scale 20-30% without adding significant costs/investment"
        },
        {
            id: "q3_9",
            text: "How favorable, documented, & transferable are supplier contracts?",
            type: "scale",
            required: true,
            benchmark: "Multi-year supplier deals with ~10%+ cost savings, fully transferable"
        },
        {
            id: "q3_10",
            text: "How optimized are your operating expenses for profitability?",
            type: "scale",
            required: true,
            benchmark: "Operating costs reduced by 10-15% annually through efficiency audits"
        },
        {
            id: "q3_11",
            text: "How comprehensive is your documented risk management plan?",
            type: "scale",
            required: true,
            benchmark: "Plan covers all major risks, reviewed biannually with mitigation"
        },
        {
            id: "q3_12",
            text: "How resilient is your business to market or industry volatility?",
            type: "scale",
            required: true,
            benchmark: "Revenue stable within 5% during past market downturns"
        },
        {
            id: "q3_13",
            text: "How current & documented are all legal contracts? No Legal Issues?",
            type: "scale",
            required: true,
            benchmark: "All contracts reviewed annually, with zero disputes or breaches"
        }
    ]
  },
  {
    id: 4,
    title: "Personal Readiness for Business Owners",
    description: "This section is optional but encouraged to provide a more complete picture of your readiness for the sale of your business",
    questions: [
        {
            id: "q4_1",
            text: "How clear is your personal identity beyond being a business owner?",
            type: "scale",
            required: false,
            benchmark: "Strong personal identity with hobbies and goals outside business."
        },
        {
            id: "q4_2",
            text: "How secure is your personal financial plan post-sale?",
            type: "scale",
            required: false,
            benchmark: "Detailed plan with diversified investments covering 20+ years."
        },
        {
            id: "q4_3",
            text: "How strong is your physical health heading into next phase of life?",
            type: "scale",
            required: false,
            benchmark: "Regular exercise and medical checkups, no health concerns."
        },
        {
            id: "q4_4",
            text: "How is your level of energy for the sale process?",
            type: "scale",
            required: false,
            benchmark: "7-8 hours sleep nightly, high energy for daily tasks."
        },
        {
            id: "q4_5",
            text: "How current is your personal estate plan for post-sale?",
            type: "scale",
            required: false,
            benchmark: "Estate plan updated within 6 months, covering all assets."
        },
        {
            id: "q4_6",
            text: "How clear are your legal protections for sale proceeds?",
            type: "scale",
            required: false,
            benchmark: "Trust or legal structure in place to protect sale proceeds."
        },
        {
            id: "q4_7",
            text: "How clear is your vision for life after the sale?",
            type: "scale",
            required: false,
            benchmark: "Detailed 5-year plan with career, travel, or philanthropy goals."
        },
        {
            id: "q4_8",
            text: "How open are you with family about the sale's impact?",
            type: "scale",
            required: false,
            benchmark: "Family fully informed, with regular discussions on changes."
        },
        {
            id: "q4_9",
            text: "How well do you leverage professional advisors?",
            type: "scale",
            required: false,
            benchmark: "Weekly consultations with CPA, lawyer, and broker."
        },
        {
            id: "q4_10",
            text: "How confident are you in navigating the process with potential buyers?",
            type: "scale",
            required: false,
            benchmark: "Trained in negotiation, with 3+ successful past deals."
        }
    ]
  }
];

export const scaleLabels = {
  1: "Non-existent",
  2: "Needs improvement", 
  3: "Below average",
  4: "Above average",
  5: "Best in class",
  6: "Industry leader"
}; 